const CONSTANT = {
  DIALOG_HEADER_HEIGHT: 48,
  OPEN_DOCUMENT_DIALOG_BODY_WIDTH: 1002,
  OPEN_DOCUMENT_DIALOG_BODY_WIDTH_RESPONSIVE: 594,
  OPEN_DOCUMENT_DIALOG_BODY_HEIGHT: 525,
  OPEN_DOCUMENT_DIALOG_SIDE_BUTTON_WIDTH: 94,
  ACTIVE_LINK_POPUP_BUTTON_RIGHT: 28, //Include scroll bar width (10px)
  ACTIVE_LINK_POPUP_BUTTON_BOTTOM: 34, //Include sdk zoom bar height (25px)
  AUTH_CHECK_TIMER: 500 //ms
};

export default CONSTANT;
